@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Treść wniosku
    </h3>
    <dl class="mb-5">
      <dt class="mb-3">
        <strong>Dane działki</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Obręb:">
              {{ application?.precint || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Działka nr:">
              {{ application?.registrationNumber || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Numer Księgi Wieczystej:">
              {{ application?.landRegister || '-' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-5">
      <dt class="mb-3">
        <strong>Dane Właścicieli/a działki</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label label="Imię nazwisko / Nazwa:">
              {{ application?.personFullName?.replaceAll('\n', ', ') || '-' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-5">
      <dt class="mb-3">
        <strong>
          Podziału przedmiotowej nieruchomości dokonuje się na podstawie przepisu artykułu
        </strong>
      </dt>
      <dd>
        @if (article(); as article) {
          <div class="row">
            <div class="col-md-4">
              <app-label label="Artykuł:">
                {{ article || '-' }}
              </app-label>
            </div>
            @if (article === 'Artykuł 95 punkt 1-8') {
              <div class="col-md-4">
                <app-label label="Punkt:">
                  {{ application?.otherArticleDescription || '-' }}
                </app-label>
              </div>
            }
            @if (article === 'Inny') {
              <div class="col-12">
                <app-label label="Inna podstawa prawna:">
                  {{ application?.otherArticleDescription || '-' }}
                </app-label>
              </div>
            }
          </div>
        }
      </dd>
    </dl>
    <dl class="mb-5">
      <dt class="mb-3">
        <strong>Informacje o wydzielanych działkach</strong>
      </dt>
      <dd>
        <app-parcels-preview [parcels]="application?.parcels || []"></app-parcels-preview>
      </dd>
    </dl>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
